'use client';

import { Prize } from '@winelivery-org/wl-client-sdk-js';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Link } from '../../../../../navigation';
import useSession from '../../../../../stores/session/useSession';
import useFindLoyaltyUserByIdQuery from '../query/useFindLoyaltyUserByIdQuery';
import Catalog from './Catalog';
import UserInfo from './UserInfo';

interface Props {
  prizes: Array<Prize>;
}

const LoyaltyShop: FC<Props> = (props) => {
  const t = useTranslations('loyalty');

  const { user } = useSession();
  const { data } = useFindLoyaltyUserByIdQuery();

  return (
    <div className="tw-space-y-8 tw-py-12">
      <h1 className="tw-text-5xl sm:tw-text-7xl tw-font-bold tw-tracking-tight tw-text-gray-800 tw-text-center tw-mb-6">
        {t('wallet.shop.title')}
      </h1>
      <UserInfo
        isAuth={!!user}
        loyaltyPoints={data?.data.loyaltyPointsAvailable || 0}
      />
      <div className="tw-text-center">
        <Link href={'/wallet'}>{t('wallet.shop.return')}</Link>
      </div>
      <Catalog prizes={props.prizes} isAuth={!!user} />
    </div>
  );
};

export default LoyaltyShop;
